<template>
    <div :class="preCls + 'content-box'">
        <div
            :class="preCls + 'filter'"
            style="display: flex; align-items: center; margin-bottom: 20px"
        >
            <form-lookup
                style="min-width: 262px; margin-right: 15px"
                v-model="selectRoom.roomId"
                :options.sync="selectRoom.roomList"
                placeholder="房源名称"
                title="选择房间"
                textSymbol="title"
                valueSymbol="id"
                :modalHeight="600"
                :modalWidth="900"
                @change="onSelectRoom"
                @clear="onClearRoom"
                @deselect="onDeselectRoom"
            >
                <select-room />
            </form-lookup>

            <DatePicker
                placement="bottom-end"
                style="width: 200px; margin-left: 12px"
                v-model="Month"
                :class="preCls + 'select-public-style'"
                transfer
                type="month"
                placeholder="注册时间"
                @on-change="search"
                :clearable="false"
            ></DatePicker>

            <check-tag-group
                style="display: inline-block"
                v-model="filter.meterTypes"
                color="primary"
                @on-change="search"
                multiple
            >
                <check-tag
                    v-for="item in dict.meterType.toList()"
                    :name="item.id"
                    :key="item.id"
                    >{{ item.text }}</check-tag
                >
            </check-tag-group>
        </div>
        <table-tool-bar>
            <template slot="left">
                <table-searcher
                    v-model="filter.cusName"
                    placeholder="请输入客户姓名或单位名称"
                    style="margin-left: 10px"
                    @search="search"
                ></table-searcher>
            </template>

            <Button
                v-if="$can('add')"
                type="primary"
                :class="preCls + 'button-margin'"
                :disabled="loading"
                @click="onClickBatchPayment"
            >
                生成账单
            </Button>

            <Button
                v-if="$can('update')"
                :class="preCls + 'button-margin'"
                :disabled="loading"
                @click="onClickConfiguration"
            >
                单价配置
            </Button>
        </table-tool-bar>
        <Table
            ref="mt"
            :editMode="editMode"
            :formula="formula"
            :columns="columns"
            :data="page.list"
            :loading="loading"
            :height="mtHeight"
            @on-select="mark"
            @on-select-cancel="cancelMark"
            @on-select-all="selectionChange"
            border
        >
            <template v-slot:readingStatus="{ row }">
                <tag-status
                    :text="dict.readingStatus.val(row.readingStatus)"
                    :color="
                        row.readingStatus == 1
                            ? 'rgb(114,183,6)'
                            : 'rgb(127,142,241)'
                    "
                    :background="
                        row.readingStatus == 1
                            ? 'rgb(243,249,233)'
                            : 'rgb(227,245,253)'
                    "
                    circle
                />
            </template>
            <template v-slot:dosage="{ row }">
                {{ row.dosage + `${hashMap[row.meterTypeText]}` }}
            </template>

            <template v-slot:price="{ row }">
                {{ (row.price / 100) | currency }}
                {{ hashsMap[row.meterTypeText] }}
            </template>

            <template v-slot:amount="{ row }">
                {{ (row.amount / 100) | currency }}
            </template>
        </Table>
        <div class="card-bottom">
            <table-pager
                :total="page.totalCount"
                :pageSize.sync="filter.pageSize"
                :pageNo.sync="filter.page"
                @change="fetch"
            >
            </table-pager>
        </div>

        <!-- 没有选中的提示框 -->
        <alter :text="modalMsg" v-model="alterShow" @closeAlter="closeAlter" />
        <!-- 选中的提示框 -->
        <confirm
            :text="modalMsg"
            v-model="modal.confirmShowInvalid"
            @closeModal="closeModalInvalid"
            @confirmModal="confirmModalInvalid"
        />
    </div>
</template>
<script>
import { mapCache } from '@/plugins/vux-data-cache'
import { deepCopy, groupBy } from '_u/helper.js'
import dayjs from 'dayjs'
import Dict from '_u/dict'

import mList from '_v/common/m-list'
import SelectRoom from '_vc/select-room'
import { readingList, readingMeter } from '@/api/bill-list'
import TagStatus from '_vc/tag-status'
import Alter from '_v/components/alter'
import Confirm from '_v/components/confirm'
import { editCell } from '_c/grid/renderCell'

export default {
    name: 'm-meter-list',
    mixins: [mList],
    components: {
        SelectRoom,
        TagStatus,
        Alter,
        Confirm,
    },
    data() {
        return {
            modal: { confirmShowInvalid: false },
            page: {
                totalCount: 0,
                list: [],
            },
            editMode: 'row',
            dict: {
                meterType: Dict.NULL,
                readingStatus: Dict.NULL,
            },
            loading: false,
            mtHeight: 360,
            selectionList: [], // 当前选中项
            alterShow: false, // 是否显示弹出框
            modalMsg: '', // 提示框内容
            selectList: [], // 要提交的选中项
            list: [],
            hashMap: {
                水表: '吨',
                电表: '度',
                热水表: '吨',
            },
            hashsMap: {
                水表: '元/吨',
                电表: '元/度',
                热水表: '元/吨',
            },
        }
    },
    computed: {
        ...mapCache({
            selectRoom: 'meterSelectRoom',
            filter: 'meterFilter',
        }),
        columns() {
            return [
                { type: 'selection', width: 60, align: 'center' },
                {
                    type: 'index',
                    minWidth: 80,
                    title: '序号',
                    align: 'center',
                },
                {
                    title: '房源名称',
                    key: 'houseName',
                    align: 'left',
                    minWidth: 180,
                    tooltip: true,
                },
                {
                    title: '客户姓名',
                    key: 'cusName',
                    align: 'left',
                    minWidth: 100,
                },
                {
                    title: '手机号',
                    key: 'cusMobile',
                    align: 'center',
                    minWidth: 120,
                    tooltip: true,
                },
                {
                    key: 'comName',
                    title: '单位名称',
                    align: 'left',
                    minWidth: 120,
                    tooltip: true,
                },
                {
                    title: '表名称',
                    key: 'meterName',
                    align: 'left',
                    minWidth: 100,
                },
                {
                    title: '抄表状态',
                    key: 'readingStatus',
                    align: 'center',
                    minWidth: 120,
                    slot: 'readingStatus',
                },
                {
                    title: '上次读数',
                    key: 'lastDegree',
                    align: 'right',
                    minWidth: 100,
                },
                {
                    title: '本次读数',
                    key: 'degree',
                    align: 'right',
                    minWidth: 100,

                    canEdit: ({ row, column, index }) => row.readingStatus == 2,
                    // 数字输入框
                    render: editCell('CellInputNumber', {
                        // 给InputNumber传递属性，注意attrs与props的区别
                        attrs: {
                            // 禁用小数
                            // allowDecimal: false,
                            // 禁用千分位
                            includeThousandsSeparator: false,
                            // 禁用负数
                            allowNegative: false,
                        },
                    }),
                },
                {
                    title: '用量',
                    key: 'dosage',
                    align: 'center',
                    minWidth: 100,
                    slot: 'dosage',
                },
                {
                    title: '单价',
                    key: 'price',
                    align: 'center',
                    minWidth: 120,
                    slot: 'price',
                    tooltip: true,
                },
                {
                    title: '应收(元)',
                    key: 'amount',
                    align: 'right',
                    minWidth: 100,
                    slot: 'amount',
                    tooltip: true,
                },
                {
                    title: '应收款日',
                    key: 'planDate',
                    align: 'center',
                    minWidth: 140,
                    canEdit: ({ row, column, index }) => row.readingStatus == 2,
                    render: editCell('CellDatePicker'),
                    tooltip: true,
                },
            ]
        },
        Month: {
            get() {
                return this.filter.belongMonth
                    ? new Date(this.filter.belongMonth)
                    : ''
            },
            set(val) {
                this.filter.belongMonth = val
                    ? dayjs(val).format('YYYY-MM')
                    : ''
            },
        },
    },
    methods: {
        fetch() {
            if (this.filter.meterTypes.length == 0) {
                this.$Message.error('请至少选择一个抄表')
            } else {
                this.loading = true
                const formate = deepCopy(this.filter)
                formate.meterTypes = formate.meterTypes.join()
                Promise.all([
                    readingList(formate),
                    Dict.get(['meter_type', 'reading_status']),
                ])
                    .then((args) => {
                        var [view, dictGroup] = args
                        Object.keys(this.dict).forEach((name) => {
                            this.dict[name] = dictGroup[name]
                        })
                        this.setPageData(view.data)
                    })
                    .finally(() => {
                        this.loading = false
                    })
            }
        },
        search() {
            this.filter.pageNo = 1
            this.fetch()
        },
        setPageData(data) {
            var list = []
            data.page.list.forEach((v) => {
                v.houseName = v.houseName.split('(')[0]
                v.meterTypeText = this.dict.meterType.val(v.meterType)
            })
            Object.values(groupBy(data.page.list, 'houseId')).forEach((g) => {
                // console.log(g);
                var first = g[0]
                first._merge = {
                    houseName: {
                        rowspan: g.length,
                    },
                    cusName: {
                        rowspan: g.length,
                    },
                    cusMobile: {
                        rowspan: g.length,
                    },
                }

                list.push(...g)
            })

            list.forEach((i, index) => {
                i.onlyId = index
                i.check = false

                if (i.readingStatus == 1) {
                    i._disabled = true
                    i.price = i.price
                } else {
                    i._disabled = false
                    i.price = i.settingPrice
                }
            })
            this.page.list = list
            this.page.totalCount = parseInt(data.page.totalCount)
            // console.log(list);
        },
        // 生成账单
        onClickBatchPayment() {
            let index = this.page.list.findIndex((i) => {
                return i.check === true
            })

            if (index >= 0) {
                this.$refs.mt
                    .validate()
                    .then(() => {
                        let list = []
                        list = this.page.list.filter((i) => i.check === true)
                        this.list = list
                        this.modalMsg =
                            '账单生成后可前往账单管理收款，是否确定？'
                        this.modal.confirmShowInvalid = true
                    })
                    .catch((err) => {
                        this.$Message.error(err[0].message)
                    })
            } else {
                this.modalMsg = '请至少选择一条记录再进行批量操作'
                this.alterShow = true
                return
            }
        },
        // 确认
        confirmModalInvalid() {
            this.list.forEach((i) => {
                i.belongMonth
                    ? (i.belongMonth = i.belongMonth)
                    : (i.belongMonth = this.filter.belongMonth)
            })
            readingMeter(JSON.stringify(this.list)).then(() => {
                this.$Message.success('账单生成成功')
                this.search()
                this.modal.confirmShowInvalid = false
            })
        },
        // 勾选中
        mark(selection, row) {
            this.page.list[row.onlyId].check = true
        },
        // 取消勾选
        cancelMark(selection, row) {
            this.page.list[row.onlyId].check = false
        },
        // 全选
        selectionChange(selection) {
            let list = this.page.list.filter((i) => {
                return (i._disabled = false)
            })
            list.forEach((v) => {
                v.check = true
            })
        },
        // 取消按钮
        closeModalInvalid() {
            this.modal.confirmShowInvalid = false
        },
        // 关闭 alter
        closeAlter() {
            this.alterShow = false
        },
        // 跳转
        onClickConfiguration() {
            this.$router.push({
                name: 'configurationIndex',
                query: { active: 'settingMeter' },
            })
        },
        formula(model) {
            var options = {
                immediate: true,
            }
            // 计算用量
            model.equation(
                (d) => d.key == 'dosage',
                (d) => {
                    if (d.row['degree'] == 0) {
                        return 0
                    } else {
                        return d.row['degree'] - d.row['lastDegree']
                    }
                },
                options
            )
            // 计算应收
            model.equation(
                (d) => {
                    return d.key == 'amount'
                },
                (d) => {
                    if (d.row['degree'] == 0) {
                        return 0
                    } else {
                        return (
                            (d.row['degree'] - d.row['lastDegree']) *
                            d.row['price']
                        )
                    }
                },
                options
            )
            // 校验
            model.verification(
                (d) => d.key == 'degree',
                (d) => [
                    {
                        validator(rule, value, callback, source, options) {
                            var msg = '本次读数必填且大于上次读数'
                            if (d.row.check === true) {
                                if (
                                    d.row.degree &&
                                    d.row.degree > d.row.lastDegree
                                ) {
                                    return callback()
                                } else {
                                    return callback(new Error(msg))
                                }
                            } else {
                                return callback()
                            }
                        },
                    },
                ]
            )

            // 校验
            model.verification(
                (d) => d.key == 'planDate',
                (d) => [
                    {
                        validator(rule, value, callback, source, options) {
                            var msg = '应收款日必填'
                            if (d.row.check === true) {
                                if (d.row.planDate) {
                                    return callback()
                                } else {
                                    return callback(new Error(msg))
                                }
                            } else {
                                return callback()
                            }
                        },
                    },
                ]
            )
        },
    },

    mounted() {
        this.afterContainerResize((el, detector) => {
            this.mtHeight =
                detector.windowHeight -
                this.$refs.mt.$el.getBoundingClientRect().top -
                80
        })
    },
    created() {
        this.fetch()
    },
    watch: {
        'filter.meterTypes': {
            handler(val, oldVal) {
                if (val.length === 0) {
                    this.filter.meterTypes = oldVal
                }
            },
        },
    },
}
</script>
